
import {decode }from 'html-entities'
// import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
// import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import { mapGetters,mapActions } from 'vuex'
import productData from '@/data/products.json'
import reviewData from '@/data/reviews.json'
// import optionsData from '@/data/options.json';

export default {
  // components: { SsrCarousel },
  async asyncData({ $page, store, route }) {
    if ($page) return { page: $page }
    else return { page: await store.dispatch('pages/getPage', route.fullPath) }
  },
    data(){
      return{
        // FAQModalShow:
        productIds: ['25','10204', '26', '10205', '18', '19', '27', '10207',  '10204', '10205', '10207', '10203', '10200', '10192', '10191', '10189', '10179', '105', '106', '10161', '1', '8'],
        reviews: reviewData,
        // Map to override descriptions that are not correctly represented in productData.json
        courseDescriptionsOverride: {
          '25':"Our best-selling 120-hour Premier Online TEFL course covers everything you need to get your first job teaching English. Get to grips with English grammar, learn about different teaching methodologies, how to plan engaging lessons, and much, much more.",
          '10204':"Offering more comprehensive training, our 250-hour Level 5 TEFL Diploma is a great option for those who would benefit from giving their CV a boost. Don’t have a degree? Not a native English speaker? No previous teaching experience? We’d recommend this Level 5 Diploma!",
          '26':"This course includes everything you’ll find in our best-selling 120-hour Premier Online course and a 20-hour weekend classroom course. With classroom locations across the UK and Ireland, as well as the option to complete it at home virtually, there are options to suit everyone.",
          '10205':"Combine our popular 250-hour Level 5 TEFL Diploma with a 20-hour classroom course. A great option for anyone looking for comprehensive TEFL training that will boost both CV and confidence.",
          '18':"Our basic combined course, the 120-hour TEFL course includes 100 hours of self-paced online study and a 20-hour weekend classroom course. Complete your classroom course in person at one of our UK and Ireland locations, or virtually over Zoom.",
          '19':"Combine 100 hours of self-paced online study with a 30-hour weekday classroom course. Complete your classroom course in person at one of our UK and Ireland locations, or virtually over Zoom.",
          '27':"Prefer to complete your classroom training during the week? This course combines our best-selling 120-hour Premier Online course with a 30-hour weekday classroom course. Complete your classroom course in person or virtually.",
          '10207':"Complete your classroom training during the week, with our 280-hour Level 5 TEFL Diploma. Combining our 250-hour Level 5 TEFL Diploma, which you’ll complete online, with a 30-hour weekday classroom course held either in person or virtually.",
          '10203':"Learn how to use AI to support English language students with this advanced TEFL course.",
          '10200':"Learn how to support neurodiverse students with conditions such as ADHD, dyslexia and autism with this advanced TEFL course.",
          '10192': "Improve your skills in lesson planning and delivery and gain valuable feedback from an experienced EFL teacher with this advanced TEFL course.",
          '10191':"Become an online English teacher and work from home - or wherever there’s an internet connection! - with our Teaching English Online course.",
          '10189':"Become certified to teach English for Academic Purposes (EAP) lessons with this Advanced TEFL course. Work with learners applying for, or studying at, English-speaking universities.",
          '10179':"Millions sit English language proficiency exams every single year. Tap into this huge market with our Teaching Exam Preparation Classes course and learn how to prepare students for a range of popular exams, such as the IELTS and TOEFL.",
          '105':"Our Teaching Young Learners course is a must for anyone aiming to work with children up to the age of 10. Make learning fun and keep young learners engaged.",
          '106':"Break into the lucrative world of Business English with this course. Learn how to develop lessons tailored to the specific needs of business learners.",
          '10161':"Get practical experience teaching English online with our Online Teaching Practice. Practice delivering lessons in front of a tutor and your peers.",
          '1':"Learn how to teach English from a highly qualified and experienced EFL tutor. Complete this course at one of our UK or Ireland locations, or do it from home virtually over Zoom. Both options cover the same syllabus.",
          '8': "This course allows you to complete your classroom training during the week and has the benefit of additional teaching practices. Complete it in person at a location of your choosing, or virtually over Zoom."
        },
        // Map to override course durations not available in productData.json (ISO 8601 format)
        courseDurationOverride: {
          '25':"P0Y6M0D",
          '10204':"P0Y7M0D",
          '26':"P0Y6M0D",
          '10205':"P0Y7M0D",
          '18':"P0Y5M0D",
          '19':"P0Y7M0D",
          '27':"P0Y7M0D",
          '10207':"P0Y7M0D",
          '10203':"P0Y1M0D",
          '10200':"P0Y1M0D",
          '10192': "P1Y0M0D",
          '10191':"P0Y2M0D",
          '10189':"P0Y2M0D",
          '10179':"P0Y2M0D",
          '105':"P0Y1M0D",
          '106':"P0Y1M0D",
          '10161':"P0Y0M3D",
          '1':"P0Y0M2D",
          '8': "P0Y0M3D"
        },
      }
    },
    head() {
        const title = this.page.seo.fullHead.child
        .map((el) => (el.tag === 'title' ? el.child[0].text : null))
        .filter((el) => el)[0]
        const metas = this.page.seo.fullHead.child.filter(
            (tag) => tag.node === 'element'
        )
        const metasArray = metas.filter((m) => m.tag === 'meta').map((m) => m.attr)
        const linkArray = metas.filter((m) => m.tag === 'link').map((m) => m.attr)
        const scriptArray = metas.filter((m) => m.tag === 'script')
        const meta = []
        const link = []
        const script = []

        if(process.env.ROBOTS === 'LIVE'){
          metasArray.push({name:'robots', content:'index, follow'})
        } else {
          metasArray.push({name:'robots', content:'noindex, nofollow'})
        }

        for (let i = 0; i < metasArray.length; i++) {
            const obj = {}
            if (metasArray[i].name) obj.name = metasArray[i].name
            if (metasArray[i].property) obj.property = metasArray[i].property
            obj.content =
                typeof metasArray[i].content === 'string'
                ? metasArray[i].content.replace(
                    /(?<!\w-)\b\w+\.tefl\.org\b/g,
                    'www.tefl.org'
                    )
                : metasArray[i].content.join(' ')

            meta.push(obj)
        }
        for (let i = 0; i < linkArray.length; i++) {
            const obj = {}
            obj.rel = linkArray[i].rel
            obj.href = linkArray[i].href.replace(
                /(?<!\w-)\b\w+\.tefl\.org\b/g,
                'www.tefl.org'
            )

            link.push(obj)
            link.push({rel:"alternate",hreflang:'en',href:"https://www.tefl.org/courses/"})
            link.push({rel:"alternate",hreflang:'x-default',href:"https://www.tefl.org/courses/"})
            link.push({rel:"alternate",hreflang:'en-US',href:"https://www.tefl.org/en-us/courses/"})
            link.push({rel:"alternate",hreflang:'en-IE',href:"https://www.tefl.org/ie/courses/"})
        }
        for (let i = 0; i < scriptArray.length; i++) {
            const obj = {}
            obj.class = scriptArray[i].attr.class
            obj.type = scriptArray[i].attr.type
            obj.innerHTML = `${scriptArray[i].child[0].text.replace(
                /(?<!\w-)\b\w+\.tefl\.org\b/g,
                'www.tefl.org'
            )}`
            script.push(obj)
        }
        script.push({type:'application/ld+json', json: this.structuredData})
        return {
            /* eslint-disable */
            title: decode(title),
            meta: meta,
            link: link,
            script: script,
            __dangerouslyDisableSanitizers: ['script'],
            /* eslint-enable */
        }
    },
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
        regionClicked : 'cart/getRegionClicked'
      }),
      products() {
        const products = this.productIds.map((id) => {return productData.find((product) => {return product.id.toString() === id})
      }).filter(Boolean); // Filter out any undefined products if an ID doesn't match
        return products
      },
      priceData() {
        const priceDataArray = []
        this.products.forEach((product) => {
          const priceD = this.$options.filters.priceData(product)
          priceDataArray.push(priceD)
        })
        return priceDataArray
      },
      prices(){
          const prices = []
          this.priceData.forEach((priceData) => {
            const price = this.$nuxt.$options.filters.priceFromLabelNumber(priceData.pricesDiscounted)
            prices.push(price)
          })
          return prices
        },
      currency(){
          const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
          return currency
        },
      levels() {
        return {
          beginner: [25, 10204, 26, 10168, 10205, 10206,18, 10167, 19, 10174, 27, 10172, 10207, 10208, 1, 10166, 8, 10171],
          advanced: [10203, 10200, 10192, 10191, 10189, 10179, 105, 106, 10161]
        }
      },

      structuredData() {
        const averageRating = this.$nuxt.$options.filters.roundScore(Number(this.reviews.stats.company.average_rating))
        const ratingCount = this.reviews.stats.company.review_count
        const baseUrl = "https://www.tefl.org"

        // Map over the 'products' array to generate structured data for each course
        const itemListElement = this.products.map((product, index) => { // Changed 'course' to 'product' for clarity here
        const coursePrice = this.prices[index] ? this.prices[index].toString() : "0"; // Fallback to "0" if price not found

        // Extract image URL from the 'page' object, prioritizing region-specific then general 'en' or 'en_us'
        const courseImage = product.page?.[this.region]?.thumbnail || product.page?.en?.thumbnail || product.page?.en_us?.thumbnail || 'https://placehold.co/400x200/cccccc/333333?text=No+Image';

        // get uri
        const uri = product.page?.[this.region]?.uri || product.page?.en?.uri || product.page?.en_us?.uri

        // Derive timeRequired and courseWorkload from 'course.hours' if available
        const courseTimeRequired = product.course?.hours ? `PT${product.course.hours}H` : '';
        const courseWorkload = product.course?.hours ? `PT${product.course.hours}H` : '';

        // get course level from arrays
        let level
        if (this.levels.beginner.includes(product.id)){
          level = 'beginner'
        }
        if (this.levels.advanced.includes(product.id)){
          level = 'advanced'
        }
        else {
          level = 'beginner'
        }

        // assign mode from product type
        let courseMode;
        if (product.type === "combined course") {
          courseMode = "blended"
        }
        else if (product.type === "classroom course") {
          courseMode = "onsite"
        }
        else {
          courseMode = "online"
        }

        // Use the overridden description if available, otherwise fallback to product.description
        const description = this.courseDescriptionsOverride[product.id.toString()] || product.description;
        // Use the overridden duration if available, otherwise fallback to empty string
        const duration = this.courseDurationOverride[product.id.toString()] || '';

        // assign prerequisites from level
        let prerequisites
        if (level === 'beginner'){
          prerequisites = 'No prior experience or qualifications are required to take this course. The course is for both native and non-native speakers. However, you must speak English fluently.'
        }
        else if (level === 'advanced') {
          prerequisites = 'It would be beneficial to have an initial TEFL qualification (e.g. 120-hr Premier Online TEFL Course) prior to taking this course.'
        }
        else {
          prerequisites = 'No prior experience or qualifications are required to take this course.The course is for both native and non-native speakers. However, you must speak English fluently.'
        }

        return {
            "position": (index + 1).toString(),
            "@type": "Course",
            "name": product.name,
            "image": courseImage,
            "url": `${baseUrl}${uri}`,
            description, // Use the determined description
            "timeRequired": courseTimeRequired,
            "learningResourceType": "Course",
            "coursePrerequisites": prerequisites,
            "offers": {
              "@type": "Offer",
              "category": "Paid",
              "price": coursePrice,
              "priceCurrency": this.currency,
              "availability": "https://schema.org/InStock",
            },
            "provider": {
              "@id": "https://www.tefl.org/#educationalorganization",
              "@type": "Organization",
              "name": "The TEFL Org",
              "logo": "https://www.tefl.org/_nuxt/images/tefl-org-web_strapline-ee5f8b.svg",
              "url": "https://www.tefl.org/",
              "sameAs": [ "https://www.facebook.com/teflorg", "https://x.com/TEFLOrg", "https://www.instagram.com/teflorg/" , "https://www.linkedin.com/company/teflorg/" ],
            },
            "hasCourseInstance": {
              "@type": "CourseInstance",
              courseMode,
              courseWorkload,
              duration,

            },
            "inLanguage": "en",
            "interactivityType": "active",

            "educationalCredentialAwarded": {
              "@type": "EducationalOccupationalCredential",
              "name": "Tefl Org Certificate",
              "credentialCategory": "Certificate",
              "url": "https://www.tefl.org/about-us/accreditation/",
              "educationalLevel": level
            },
            "audience": {
              "@type": "Audience",
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
            },
            "about": "Teaching English as a Foreign Language",
            "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": averageRating,
            ratingCount,
            "bestRating": 5
            },
          }
        });

        return {
          "@context": "https://schema.org/",
          "@type": "ItemList",
          itemListElement
        };
      },
    },
    methods:{
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal',
        }),
        updateModal(id){
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        },
        limit(string, limit){
          return string.substring(0, limit)+"..."
        }
    },
}
